'use client'

import { Builder, withChildren } from '@builder.io/react'

import {
  ANALYTICS_MODULE_INPUT,
  AnalyticsEvents,
} from '@src/hooks/useClickAction/useClickAction.builder'

import { CdpTile } from './CdpTile'

Builder.registerComponent(withChildren(CdpTile), {
  name: 'CdpTile',
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      class: 'cdp-tile-image',
      component: {
        name: 'Image',
        options: {
          image:
            'https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F72c80f114dc149019051b6852a9e3b7a',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          lazy: false,
          fitContent: true,
          lockAspectRatio: true,
        },
      },
    },
  ],
  description: 'CDP Tile',
  defaultStyles: {
    alignItems: 'center',
  },
  inputs: [
    {
      name: 'title',
      friendlyName: 'Tile Title',
      type: 'text',
      localized: true,
      defaultValue: 'Title...',
    },
    {
      name: 'description',
      friendlyName: 'Tile Description',
      type: 'text',
      localized: true,
      defaultValue: 'Description',
    },
    {
      name: 'featureTags',
      friendlyName: 'Feature Tags',
      type: 'list',
      defaultValue: [],
      subFields: [{ name: 'value', type: 'text' }],
    },
    {
      name: 'price',
      friendlyName: 'Price',
      type: 'text',
      localized: true,
    },
    {
      name: 'promotionalPrice',
      friendlyName: 'Promotional Price',
      type: 'text',
      localized: true,
    },
    {
      name: 'href',
      friendlyName: 'Redirect url',
      type: 'text',
      localized: true,
    },
    {
      name: 'target',
      friendlyName: 'Tab Behavior',
      helperText: 'Determines if the link opens in the same or new tab. Default is "Same tab".',
      type: 'enum',
      enum: [
        { value: '_self', label: 'Same tab' },
        { value: '_blank', label: 'New tab' },
      ],
      defaultValue: '_self',
    },
    {
      name: 'analyticsEvent',
      friendlyName: 'Analytics Event',
      type: 'enum',
      defaultValue: 'none',
      enum: AnalyticsEvents.map(String),
    },
    ANALYTICS_MODULE_INPUT,
  ],
})
